import Button from '@hotmart/space-lib/dist/components/button'
import ModalBody from '@hotmart/space-lib/dist/components/modalBody'
import ModalFooter from '@hotmart/space-lib/dist/components/modalFooter'
import ModalHeader from '@hotmart/space-lib/dist/components/modalHeader'

import '@hotmart/cosmos/dist/styles/utilities/screenreaders.css'
import i18n from 'src/i18n'
import Modal from 'src/components/Modal'

import { RiCloseLine } from '@remixicon/react'
import { PostLeaveModalProps } from './types'
import { ConfirmLeaveButton } from './postLeaveModal.styles'

const PostLeaveModal = ({ isOpen, onClose, onKeepEditing }: PostLeaveModalProps) => {
  return (
    <Modal show={isOpen} onClose={onClose}>
      <ModalHeader className="_px-5 _pt-5 _pb-4">
        <div className="_d-flex _align-items-baseline">
          <h2 className="_text-3 _m-0 _mr-4 _font-weight-semibold">
            {i18n.t('modals.publish_post_leave.title_2')}
          </h2>

          <Button
            variation="tertiary"
            className="_p-0 _d-flex _border-0 _bg-transparent _ml-auto"
            onClick={onClose}
          >
            <span className="_sr-only">close</span>
            <RiCloseLine size={24} />
          </Button>
        </div>
      </ModalHeader>

      <ModalBody className="_p-0 _px-5">
        <p className="_text-2 _text-gray-500 _m-0">
          {i18n.t('modals.publish_post_leave.description_2')}
        </p>
      </ModalBody>

      <ModalFooter className="_px-5 _py-5">
        <div className="_d-flex _ml-auto">
          <Button className="_bg-transparent _mr-5" variation="default" onClick={onKeepEditing}>
            {i18n.t('modals.publish_post_leave.buttons.keep_editing')}
          </Button>

          <ConfirmLeaveButton
            className="_d-flex _align-items-center _px-3 _py-2 text-white _font-weight-light _bg-blue"
            onClick={onClose}
          >
            {i18n.t('modals.publish_post_leave.buttons.leave_2')}
          </ConfirmLeaveButton>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default PostLeaveModal
